import React from 'react';
import { View, Text, StyleSheet, ViewProps } from 'react-native';

interface AuthDividerProps extends ViewProps {
  label: string;
}

export default function AuthDivider({ label, style, ...props }: AuthDividerProps) {
  return (
    <View style={[styles.container, style]} {...props}>
      <View style={styles.line} />
      <Text style={styles.label}>{label}</Text>
      <View style={styles.line} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    width: '100%',
    paddingVertical: 8,
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: '#F0EEE4',
  },
  label: {
    fontSize: 14,
    fontFamily: 'Inter_500Medium',
    lineHeight: 20,
    fontWeight: '500',
    color: '#151515',
  },
});
